import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import cn from 'classnames';

import { PermissionsConsumer } from 'components/composed/Permissions';
import { appConfig } from 'constants/appConfig';
import { ROUTES_WAYS } from 'constants/routesWays';
import { PTMatch } from 'propTypes';

import { ACCESS_PERMISSIONS } from '../constants';

import { checkPermissions } from 'magic/permissions';
import { useSelector } from 'react-redux';
import PermissionsContext from 'components/composed/Permissions/PermissionsContext';
import { PERMISSIONS } from 'constants/permissions';

import styles from './Links.scss';

const Links = ({ match, variant = 'default' }) => {
  const isControlIndicators = match.path === ROUTES_WAYS.CONTROL_INDICATORS;

  const userPermissions = useContext(PermissionsContext);
  const hasNewCompetitionsAccess = checkPermissions(false, false, 'global', userPermissions, [PERMISSIONS.NEW_COMPETITION]);

  const competitionsAddress = useSelector((state) => state.competitionsIntegrationReducer?.address);

  const linkClass = variant === 'dropdown' ? styles.dropdownLink : styles.navigationLink;

  return (
    <>
      <Link to={ROUTES_WAYS.MANAGEMENT} className={cn(linkClass, { [styles.active]: !isControlIndicators })}>
        Паспортизация
      </Link>

      {appConfig.TRANSFER_HOST && (
        <a href={appConfig.TRANSFER_HOST} rel="noopener noreferrer" className={linkClass}>
          Контракты и переходы
        </a>
      )}

      <PermissionsConsumer permissions={ACCESS_PERMISSIONS.COMPETITION}>
        <a href={hasNewCompetitionsAccess ? `${competitionsAddress}/competition-management/` : '/ords/f?p=1:1'} className={linkClass}>
          Соревнования
        </a>
      </PermissionsConsumer>

      {appConfig.LICENSE_HOST && (
        <a href={appConfig.LICENSE_HOST} rel="noopener noreferrer" className={linkClass}>
          Лицензирование
        </a>
      )}

      {appConfig.TALENTS_HOST && (
        <a href={appConfig.TALENTS_HOST} rel="noopener noreferrer" className={linkClass}>
          Наша смена
        </a>
      )}

      {appConfig.REFEREE_HOST && (
        <a href={appConfig.REFEREE_HOST} rel="noopener noreferrer" className={linkClass}>
          Арбитры
        </a>
      )}

      {appConfig.TRAVEL_HOST && (
        <a href={appConfig.TRAVEL_HOST} rel="noopener noreferrer" className={linkClass}>
          Выезды ЮФЛ
        </a>
      )}

      {appConfig.NOTIFY_HOST && (
        <a href={appConfig.NOTIFY_HOST} rel="noopener noreferrer" className={linkClass}>
          Уведомления
        </a>
      )}

      <PermissionsConsumer permissions={ACCESS_PERMISSIONS.STRATEGY}>
        <Link to={ROUTES_WAYS.CONTROL_INDICATORS} className={cn(linkClass, { [styles.active]: isControlIndicators })}>
          Стратегия 2030
        </Link>
      </PermissionsConsumer>
    </>
  );
};

Links.propTypes = {
  match: PropTypes.shape(PTMatch).isRequired,
  variant: PropTypes.oneOf(['default', 'dropdown']),
};

export default withRouter(Links);
